import { h } from "preact";

export const QuantityMinus = () => (
  <svg
    className="icon"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.6665 8L11.3332 8"
      stroke="currentColor"
      stroke-width="1.25"
      stroke-linecap="square"
    />
  </svg>
);

export const QuantityPlus = () => (
  <svg
    className="icon"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.99984 4.66663V11.3333M4.6665 7.99996H11.3332"
      stroke="currentColor"
      stroke-width="1.25"
      stroke-linecap="square"
    />
  </svg>
);

export const Info = () => (
  <svg
    className="icon"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.63031 4.80006H6.88031V8.90006H5.63031V4.80006ZM5.63031 3.09006H6.88031V4.34006H5.63031V3.09006ZM0.570312 6.00006C0.570312 9.14006 3.12031 11.6901 6.26031 11.6901C9.40031 11.6901 11.9503 9.14006 11.9503 6.00006C11.9503 2.86006 9.40031 0.310059 6.26031 0.310059C3.12031 0.310059 0.570312 2.86006 0.570312 6.00006Z"
      fill="currentColor"
    />
  </svg>
);

export const Tag = () => (
  <svg
    className="icon"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.4052 6.375L6.75 1.71985C6.68061 1.6499 6.59801 1.59444 6.507 1.5567C6.41598 1.51896 6.31838 1.49969 6.21985 1.5H1.875C1.77555 1.5 1.68016 1.53951 1.60984 1.60984C1.53951 1.68016 1.5 1.77555 1.5 1.875V6.21985C1.49969 6.31838 1.51896 6.41598 1.5567 6.507C1.59444 6.59801 1.6499 6.68061 1.71985 6.75L6.375 11.4052C6.44465 11.4748 6.52734 11.5301 6.61834 11.5678C6.70935 11.6055 6.80689 11.6249 6.9054 11.6249C7.0039 11.6249 7.10144 11.6055 7.19245 11.5678C7.28345 11.5301 7.36614 11.4748 7.43579 11.4052L11.4052 7.43579C11.4748 7.36614 11.5301 7.28345 11.5678 7.19245C11.6055 7.10144 11.6249 7.0039 11.6249 6.9054C11.6249 6.80689 11.6055 6.70935 11.5678 6.61834C11.5301 6.52734 11.4748 6.44465 11.4052 6.375ZM6.90516 10.875L2.25 6.21985V2.25H6.21985L10.875 6.90516L6.90516 10.875ZM4.5 3.9375C4.5 4.04876 4.46701 4.15751 4.40521 4.25001C4.3434 4.34251 4.25555 4.41461 4.15276 4.45719C4.04998 4.49976 3.93688 4.5109 3.82777 4.4892C3.71865 4.46749 3.61842 4.41392 3.53976 4.33525C3.46109 4.25658 3.40752 4.15636 3.38581 4.04724C3.36411 3.93813 3.37525 3.82503 3.41782 3.72224C3.4604 3.61946 3.53249 3.53161 3.625 3.4698C3.7175 3.40799 3.82625 3.375 3.9375 3.375C4.08669 3.375 4.22976 3.43427 4.33525 3.53976C4.44074 3.64525 4.5 3.78832 4.5 3.9375Z"
      fill="currentColor"
    />
  </svg>
);
